import React from 'react';

import { useDeleteFile } from '@vlabs/api/point-api/client';
import { DeleteIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button/IconButton.js';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { useDeleteCardFileTranslation } from './i18n';
import type { DeleteCardFileProps } from './types';

type DeleteCardFileIconButtonProps = DeleteCardFileProps & IconButtonProps;

const displayName = 'DeleteCardFileIconButton';
const testid = buildTestid(displayName);

function DeleteCardFileIconButton({
  fileId = undefined,
  onDeleteCardFile = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: DeleteCardFileIconButtonProps): React.JSX.Element | null {
  const { t } = useDeleteCardFileTranslation();
  const deleteFile = useDeleteFile({
    mutation: {
      onSuccess: () => {
        onDeleteCardFile?.();
      },
    },
  });

  if (!fileId) return null;

  return (
    <IconButton
      icon={<DeleteIcon />}
      kind="negative"
      onClick={() => deleteFile.mutate({ fileId })}
      title={t('title')}
      variant="flat"
      {...testid(dataTestId, fileId)}
      {...props}
    />
  );
}

DeleteCardFileIconButton.displayName = displayName;

export { DeleteCardFileIconButton };
